import React, { useState } from 'react';
import ShareDialog from '../Shared/Dialogs/ShareDialog';
import {IconButton } from '@mui/material';
import { QrCode as QrCodeIcon } from 'lucide-react';

function QrButton(props) {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton style={{ borderRadius: props.borderRadius ? props.borderRadius : 0 }} disabled={props.disabled} onClick={handleClickOpen} size='large' {...props}>
                <QrCodeIcon fontSize="inherit" />
            </IconButton>

            {open &&

                <ShareDialog openQr={open} handleCloseQr={handleClose} projectQR={props.QrCode} projectName={props.projectName} resourceName={props.resourceName}></ShareDialog>
            }
        </div>
    )

}

export default QrButton;